var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-v-c959041a": "",
    id: "ProfileIcon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 668.8 668.9",
    xmlSpace: "preserve",
    className: "",
    width: 668.8,
    height: 668.9,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-v-c959041a": "",
    className: "sub_one"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    "data-v-c959041a": "",
    className: "st0",
    cx: 335.5,
    cy: 211.3,
    r: 173.7,
    stroke: "#909090",
    fill: "none",
    strokeWidth: "50px"
  })), /*#__PURE__*/React.createElement("circle", {
    "data-v-c959041a": "",
    className: "st1",
    cx: 335.5,
    cy: 211.3,
    r: 173.7,
    style: {},
    stroke: "#000000",
    fill: "none",
    strokeWidth: "63px"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-v-c959041a": "",
    className: "st0",
    d: "M48.5,634.4v-64.1c0-51.2,41.9-93.1,93.1-93.1h388.8c51.2,0,93.1,41.9,93.1,93.1v64.1",
    stroke: "#909090",
    fill: "none",
    strokeWidth: "50px"
  })), /*#__PURE__*/React.createElement("path", {
    "data-v-c959041a": "",
    className: "st1",
    d: "M48.5,634.4v-64.1c0-51.2,41.9-93.1,93.1-93.1h388.8c51.2,0,93.1,41.9,93.1,93.1v64.1",
    style: {},
    stroke: "#000000",
    fill: "none",
    strokeWidth: "63px"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPIcon);
export default __webpack_public_path__ + "static/media/p-icon.1b822853b5c8b3bf6eaa5a3bfd6754ed.svg";
export { ForwardRef as ReactComponent };